// extracted by mini-css-extract-plugin
export default {"historyBox":"Rn7Zt2V2RbUtHXZmFM4q","info":"Q7q9s4eA015VI7KLaghC"};